import React from 'react';

import { Button, Form, Modal } from 'antd';
import { t } from 'i18next';

import { useAppSelector, useNotification } from 'segments/hooks';

import { selectActiveGroupeId } from 'features/groups';
import { SelectUsers, useAddUserToGroupeMutation } from 'features/users';

interface FormValues {
  userId: number;
}

type Props = {
  isModalOpen: boolean;
  handleCancel: () => void;
};

export const AddUser = (props: Props) => {
  const {
    isModalOpen,
    handleCancel,
  } = props;

  const selectedGroupeId = useAppSelector(selectActiveGroupeId);
  const [addUser, { isLoading: addingLoading, isSuccess: addingSuccess, isError: addingError, error }] = useAddUserToGroupeMutation();
  const [form] = Form.useForm();

  useNotification({
    isSuccess: addingSuccess,
    isError: addingError,
    error,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });

  if (selectedGroupeId === null) {
    return;
  }

  const onFinish = ({ userId }: FormValues) => {
    addUser({
      groupeId: selectedGroupeId,
      userId
    });
  };

  return (
    <Modal
      open={isModalOpen}
      title={t('user.add-groupe')}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="vertical"
        onFinish={onFinish}
        form={form}
        disabled={addingLoading}
        className="wallets-operations-form"
      >
        <SelectUsers oneSelectMode formProps={{
          rules: [{ required: true }]
        }}
        />
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t('user.go', 'Выполнить')}
        </Button>
      </Form>
    </Modal>
  );
};
